export const SUPPORTED_CURRENCIES = ['USD', 'EUR', 'GBP', 'RUB', 'TRY', 'NGN', 'GHS', 'UGX'] as const;

export type SupportedCurrency = (typeof SUPPORTED_CURRENCIES)[number];

// Verified against Intl.NumberFormat's resolved options (CLDR/ISO 4217): UGX has 0 digits.
export const ISO_FRACTION_DIGITS: Record<SupportedCurrency, number> = {
    USD: 2,
    EUR: 2,
    GBP: 2,
    RUB: 2,
    TRY: 2,
    NGN: 2,
    GHS: 2,
    UGX: 0
};

export class UnsupportedCurrencyError extends Error {
    constructor(public readonly code: string) {
        super(`Unsupported currency: ${code}`);
        this.name = 'UnsupportedCurrencyError';
    }
}

export function isSupportedCurrency(code: string): code is SupportedCurrency {
    return (SUPPORTED_CURRENCIES as readonly string[]).includes(code);
}

export function assertSupportedCurrency(code: string): asserts code is SupportedCurrency {
    if (!isSupportedCurrency(code)) {
        throw new UnsupportedCurrencyError(code);
    }
}

export function isoFractionDigits(code: SupportedCurrency): number {
    return ISO_FRACTION_DIGITS[code];
}
